import EditorActionFooter from "components/common/EditorActionFooter";

interface Props {
  onCancel?: () => void;
  onApply?: () => void;
  applyButtonCaption?: string;
}

export default function SubscriptionConfirmationActionFooter(props: Props) {
  const { onCancel, onApply, applyButtonCaption } = props;
  return (
    <div className="mt-7 flex justify-end">
      <EditorActionFooter
        onCancel={onCancel}
        onApply={() => onApply?.()}
        applyButtonCaption={applyButtonCaption}
      />
    </div>
  );
}
